import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737d4646"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tabs",
  "data-ts": "tabs"
}
const _hoisted_2 = ["data-ts", "disabled", "onClick"]

interface TabProps {
	label: string;
	id: string;
	iconName?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: {},
    activeTabId: {},
    disabled: { type: Boolean }
  },
  emits: ["selectTab"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function handleTabClick<T extends string>(tabId: T): void {
	if (tabId !== props.activeTabId) emit('selectTab', tabId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tab.id,
        type: "button",
        "data-ts": `tab-${tab.id}`,
        disabled: _ctx.disabled,
        tabindex: "0",
        class: _normalizeClass([
				'tabs__tab',
				{
					'tabs__tab--current': tab.id === _ctx.activeTabId,
					'tabs__tab--disabled': _ctx.disabled,
				},
			]),
        onClick: ($event: any) => (handleTabClick(tab.id))
      }, [
        (tab.iconName)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(`bx ${tab.iconName} mr-1 text-md`)
            }, null, 2))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(tab.label), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})